import axios from "axios";
import { getApiBaseUrl } from "../apiBaseUrlFinder";

export const reviewsService = {
  // Get trending reviews
  getTrendingReviews: async (count = 4) => {
    const response = await fetch(
      `${getApiBaseUrl()}/trending_reviews?review_count=${count}`
    );
    const data = await response.json();

    return data.map((review) => ({
      timeAgo: review.creation_time,
      name: review.manager_full_name,
      rating: review.review_rating,
      location: review.manager_location,
      likes: review.likes,
      dislikes: review.dislikes,
      company_name: review.company_name,
      manager_id: review.manager_id,
      manager_full_name: review.manager_full_name,
      manager_position: review.manager_position,
      review: review.review,
      negative_tags: review.negative_tags,
      positive_tags: review.positive_tags,
      review_id: review.review_id,
      company_id: review.company_id,
      company_logo_url: review.company_logo_url,
      is_verified: review.is_verified,
    }));
  },

  // Get user's rated managers
  getUserRatedManagers: async (lastKey = null) => {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("No authentication token found");
    }

    let url = `${getApiBaseUrl()}/rated_managers`;
    if (lastKey) {
      url += `?last_key=${encodeURIComponent(lastKey)}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  },

  // Get user's saved managers
  getUserSavedManagers: async (lastKey = null) => {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("No authentication token found");
    }

    let url = `${getApiBaseUrl()}/get_saved_manager`;
    if (lastKey) {
      url += `?last_key=${encodeURIComponent(lastKey)}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  },

  // Update review engagement (like/dislike/report)
  updateReviewEngagement: async (reviewData) => {
    const payload = {
      manager_id: reviewData.manager_id,
      manager_full_name: reviewData.manager_full_name,
      review_id: reviewData.review_id,
      like: reviewData.like,
      dislike: reviewData.dislike,
      reported: reviewData.reported,
    };

    const response = await axios.put(
      `${getApiBaseUrl()}/review_engagement`,
      payload
    );
    return response.data;
  },
};
